import { useNavigate } from "react-router-dom";

const AdminButton = () => {
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem("isAdmin") === "true";

    const handleLogin = () => {
        const pass = prompt("Enter your admin password:");

        // 💡 Usa una contraseña secreta solo tú conoces
        if (pass === "yourSuperSecretPassword") {
            localStorage.setItem("isAdmin", "true");
            window.location.reload();
        } else {
            alert("❌ Incorrect password");
        }
    };

    if (!isAdmin) return null;

    return (
        <button
            onClick={() => navigate("/admin/new-post")}
            className="fixed bottom-6 right-6 bg-primary text-white px-4 py-2 rounded-full shadow-lg hover:bg-secondary transition-all z-50"
        >
            + New Post
        </button>
    );
};

export default AdminButton;
